import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectShowDetail } from 'store/Contextualization/AssetDetail/selectors';
import { redirectToManage } from 'store/Contextualization/AssetDetail/actions';
import Title from '../Title';
import {
  Wrapper,
  CloseIconWrapper,
  CloseIcon
} from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Header/styled';

const Header = () => {
  const dispatch = useDispatch();
  const show = useSelector((state) => selectShowDetail('vulns', state));

  if (!show) return null;
  return (
    <Wrapper>
      <Title />
      <CloseIconWrapper onClick={ () => dispatch(redirectToManage()) }>
        <CloseIcon />
      </CloseIconWrapper>
    </Wrapper>
  );
};

export default Header;
